module.exports = __webpack_public_path__ + "static/img/emoji_5.ae1aac45.png";